import React, { useEffect } from "react";
import { LivetickerTeaserEntry } from "../helper/interfaces";
import { TeaserData } from "./teaser";
import Script from 'next/script'
import { useLoggedRouter } from "../helper/useLoggedRouter";
import { getRessortAd } from "./Ad";
import { createPortal } from 'react-dom';
import AdPortals from "./AdPortals";

export interface LiveblogThemeConfiguration {
  colorScheme: string
  liveblogId: string
  clientId: string
  themeId: string
  sort: string
}

type LiveblogTagProps = {
  [Property in keyof LiveblogThemeConfiguration]?: string;
}

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'tickaroo-liveblog': LiveblogTagProps & React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement> & { initialData?: string }
    }
  }
}

export default function TeaserLiveticker(data: TeaserData) {
  const [routerPush] = useLoggedRouter();

  const teaser = data.teaser as LivetickerTeaserEntry;
  const liveblogId = `liveblog-${teaser?.providerId}`

  const updateTicker = () => {
    const ticker = document.getElementById(liveblogId);
    if(ticker) {
      // eslint-disable-next-line
      (ticker as any).loadMoreTop();
    }
  }

  useEffect(() => {
   //on change of document
   document.addEventListener('DOMNodeInserted', (event) => {
    const adSlots = document.querySelectorAll('.liveblog-ad');
    adSlots.forEach((adSlot) => {
      createPortal(getRessortAd({ id: adSlot.id, className: adSlot.className }), adSlot);
      
    });
   });
  }, []);

  useEffect(() => {
    const liveblog = document.getElementById(liveblogId);
    const handleClick = async function(e) {
      let target = e.target.closest('a[target="_blank"]');
      if (target) {
        const url = target.href;

        const regex = /http.*[-\/](\d[.]\d*)/i;
        const found = url.match(regex)
        let id: string | undefined = undefined
        if(found?.length == 2) {
          id = found[1]
        }
        
        if (id) {
          e.preventDefault();
          if(id.startsWith("1") && !url.includes(`/ressort/${id}`)) {
            await routerPush(`/article/${id}`)
          }
          else {
            await routerPush(`/ressort/${id}`)
          }
        }
      }
    };

    const createAdSlot = (index: number) => {
        const adPosition = index  + 1;
        return '<div class="react-ad-slot" id="react-ad-' + adPosition + '" data-react-ad-id="' + adPosition + '"></div>';
    };


    const handleTickarooLiveblogInit = async function(e) {
      if (liveblog) {
        const adManager = new ((window as any).tik4 as any).ScheduledAdManager(3, 6, createAdSlot);
        (liveblog as any).setAdManager(adManager);
      }
    };

    if (liveblog) {
      liveblog.addEventListener("click", handleClick);
      liveblog.addEventListener("tickarooLiveblogInit", handleTickarooLiveblogInit);
    }

    return () => {
      if (liveblog) {
        liveblog.removeEventListener("click", handleClick);
        liveblog.removeEventListener("tickarooLiveblogInit", handleTickarooLiveblogInit);
      }
    };
  }, []);

  return (
    <React.Fragment>
      <div className="liveticker">
        <div>
          {teaser?.title && <h6 className="modul__teaser__headline modul__teaser__headline--sec" aria-label={teaser.title}>{teaser.title}</h6>}
        </div>
        <div id="tickaroo-liveblog"></div>
        <Script id="tik4" src="https://cdn.tickaroo.com/webng/embedjs/tik4.js"></Script>
        {teaser.themeId &&
          <tickaroo-liveblog id={liveblogId} liveblogId={`${teaser.providerId}`} themeId={`${teaser.themeId}`} sort={teaser.historicalTicker ? "asc" : "desc"} clientId="56a60a0ee4b01f3db90f4652"></tickaroo-liveblog>
        }
        {!teaser.themeId &&
          <tickaroo-liveblog id={liveblogId} colorScheme="auto" liveblogId={`${teaser.providerId}`} sort={teaser.historicalTicker ? "asc" : "desc"} clientId="56a60a0ee4b01f3db90f4652"></tickaroo-liveblog>
        }
        <AdPortals
          rootSelector={`#${liveblogId}`}
          slotSelector=".react-ad-slot"
          render={function (index: number | undefined) { return getRessortAd({ id: `traffective-ad-Ticker_${index}`, className: "liveblog-ad Ticker" }); }}
        />
      </div>
    </React.Fragment>
  );
}